module.exports = __webpack_public_path__ + "img/f5.18cf634a.png";